<template>
	<div class="date-block mb-[24px]">
		<span class="flex gap-1 items-center">
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M6 1V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H18V1H16V3H8V1H6ZM5 8H19V19H5V8ZM13 13V17H17V13H13Z"
					fill="#475569"
				/>
			</svg>
			Updated {{ formatPostDate(date) }}
		</span>

		<span class="flex gap-1 items-center">
			<svg
				width="24"
				height="24"
				viewBox="0 0 24 24"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2ZM15.293 16.707L11 12.414V6H13V11.586L16.707 15.293L15.293 16.707Z"
					fill="#475569"
				/>
			</svg>
			{{ readingTime }} min read
		</span>
	</div>
</template>

<script lang="ts" setup>
type Props = {
	date: string;
	readingTime?: number;
};

defineProps<Props>();
</script>
<style lang="scss" scoped>
@import "@assets/utils.scss";

.date-block {
	display: flex;
	align-items: center;
	gap: 16px;
	color: $neutral-600;
}
</style>
